module.exports = __webpack_public_path__ + "static/media/custard-apple.2bb012ff.svg";